import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const EmployeeTypeTable = ({ data, onEdit, currentPage, setCurrentPage }) => {
  const headers = [
    "ID", "Code", "Description", "Operation Benefit Eligible",
    "Partial Salary Eligible", "Allow Fixed Logs", "Leave Incentive",
    "Maintenance Salary Combination", "Status", "Actions"
  ];

  const accessors = [
    "id", "code", "description", "isOperationBenefitEligible",
    "isPartialSalaryEligible", "allowFixedLogs", "leaveIncentiveFixDays",
    "maintenanceSalaryCombinationDisregardOtherFilter", "isActive", "actions"
  ];

  const getStatusBadge = (isActive) => (
    <span className={`px-2 py-1 text-xs rounded-full ${isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
      {isActive ? "Active" : "Inactive"}
    </span>
  );

  const getEligibilityBadge = (isEligible) => (
    <span className={`px-2 py-1 text-xs rounded-full ${isEligible ? "bg-blue-100 text-blue-800" : "bg-gray-100 text-gray-600"}`}>
      {isEligible ? "Eligible" : "Not Eligible"}
    </span>
  );

  const getIsAllowedBadge = (isAllowed) => (
    <span className={`px-2 py-1 text-xs rounded-full ${isAllowed ? "bg-purple-100 text-purple-800" : "bg-gray-100 text-gray-600"}`}>
      {isAllowed ? "Allowed" : "Not Allowed"}
    </span>
  );

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Employee Types"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={(row, accessor) => {
        if (accessor === "isActive") return getStatusBadge(row.isActive);
        if (accessor === "isOperationBenefitEligible") return getEligibilityBadge(row.isOperationBenefitEligible);
        if (accessor === "isPartialSalaryEligible") return getEligibilityBadge(row.isPartialSalaryEligible);
        if (accessor === "allowFixedLogs") return getIsAllowedBadge(row.allowFixedLogs);
        if (accessor === "maintenanceSalaryCombinationDisregardOtherFilter") return getIsAllowedBadge(row.maintenanceSalaryCombinationDisregardOtherFilter);
        if (accessor === "leaveIncentiveFixDays") return (
          <div className="flex flex-col gap-1 text-xs">
            <div className="flex items-center gap-1.5">
              <span className="text-gray-500">Fix:</span>
              <span className="rounded bg-blue-50 px-1.5 py-0.5 font-medium text-blue-700">{row?.leaveIncentiveFixDays ?? 0}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-gray-500">Absents:</span>
              <span className="rounded bg-amber-50 px-1.5 py-0.5 font-medium text-amber-700">{row?.leaveIncentiveAllowedAbsents ?? 0}</span>
            </div>
          </div>
        );
        return null;
      }}
    />
  );
};

export default EmployeeTypeTable;